jQuery(document).ready(function () {
    jQuery('.event-location-picker').change(function () {
        if (jQuery(this).val() == 'regionallocal') {
            jQuery('.location-fields').show();
            checkZipcode();
        } else {
            jQuery('.location-fields').hide();
            jQuery('.search-btn').removeClass('disabled');
            jQuery("#zipcode").val('');
        }
    });

    jQuery(".zipcode-field").keyup(function () {
        checkZipcode();
    });

    // slider toggle
    jQuery('.filter-tag').click(function() {
        jQuery( '.filter-slider' ).toggleClass( "open" );
    });
});

function checkZipcode() {

    var zipCheck = isValidUSZip(jQuery(".zipcode-field").val());

    if (zipCheck === true) {
        clearZipError('');
        jQuery('.search-btn').removeClass('disabled');
    } else if (zipCheck === false) {
        showZipError('');
        jQuery('.search-btn').addClass('disabled');
    }
}

function clearZipError() {
    jQuery('.coord-error').hide();
}

function showZipError(param_error) {
    jQuery('.coord-error').show();
}

function isValidUSZip(sZip) {
    return /^\d{5}(-\d{4})?$/.test(sZip);
}


function createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(c_name) {
    var i,x,y,ARRcookies=document.cookie.split(";");
    for (i=0;i<ARRcookies.length;i++)
    {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name)
        {
            return unescape(y);
        }
    }
}
